"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentSchemeForm = void 0;
const mithril_1 = __importDefault(require("mithril"));
const payment_1 = require("../../../model/payment");
const helpers_1 = require("../../../utils/helpers");
const rest_provider_1 = require("../../../utils/rest_provider");
const form_for_1 = require("../../../widgets/form_for");
const modal_1 = require("../../../widgets/modal");
const notification_center_1 = require("../../../widgets/notification_center");
const contract_show_1 = require("../contract/contract_show");
const contract_table_1 = require("../contract/contract_table");
const payment_table_1 = require("./payment_table");
const moment = require("moment");
function renderPaymentLine(payment, idx) {
    return [
        (0, mithril_1.default)(".columns", (0, mithril_1.default)(".column.is-1", (0, mithril_1.default)("div", { class: "field", style: "text-align: center" }, (0, mithril_1.default)("label", { class: "label", style: "text-align: left", for: `payment-${idx}` }, "Payé"), (0, form_for_1.checkbox)("", "paid", payment, { id: `payment-${idx}` }))), (0, mithril_1.default)(".column", (0, form_for_1.field)("Montant", "value", "number", payment, {
            renderValue: (0, helpers_1.renderMoneyInput)(),
            transformValue: (0, helpers_1.transformMoneyInput)()
        })), (0, mithril_1.default)(".column", (0, form_for_1.selectField)("Type", "payment_type", payment_1.PAYMENT_TYPES, payment, {}))),
        (0, mithril_1.default)(".columns", (0, mithril_1.default)(".column", (0, form_for_1.field)("Dû le", "due_at", "date", payment, {})), (0, mithril_1.default)(".column", (0, form_for_1.field)("Payé le", "paid_at", "date", payment, { disabled: !payment.paid })))
    ];
}
function isIllegal(form) {
    if (form.obj.total_amount) {
        return form.obj.total_amount.raw != computeTotal(form).raw;
    }
    else {
        return false;
    }
}
function renderPayments(form) {
    if (!form.obj.contract_id)
        return;
    renderPaymentScheme(form); // Super crade mais je veux preparer le modele notamment apres modification du nombre de paiements
    let totalAmount = (0, helpers_1.moneyToString)(form.obj.total_amount);
    let computedAmount = (0, helpers_1.moneyToString)(computeTotal(form));
    let isDanger = isIllegal(form);
    return (0, mithril_1.default)("div", form.field("Nombre de paiements", "installment_count", "number", { min: 1 }), (0, mithril_1.default)("hr"), renderPaymentScheme(form), (0, mithril_1.default)("div", (0, mithril_1.default)("div", { class: `${isDanger ? "has-text-danger" : ""}` }, "Total: ", computedAmount, "/", totalAmount)));
}
function computeTotal(form) {
    let total = { raw: 0 };
    form.obj.payments.forEach((p) => {
        total = (0, helpers_1.moneyAdd)(total, p.value);
    });
    return total;
}
function renderPaymentScheme(form) {
    if (!form.obj.contract_id) {
        return undefined;
    }
    let payments = form.obj.payments;
    const installment_count = Math.max(0, form.obj.installment_count || 0);
    payments.length = installment_count;
    let out = [];
    for (let i = 0; i < installment_count; i++) {
        if (payments[i] == undefined) {
            payments[i] = {
                value: { raw: form.obj.total_amount.raw / installment_count },
                due_at: moment().add(i, "month").format("YYYY-MM-DD"),
                paid_at: undefined,
                payment_type: "check",
                paid: false,
            };
        }
        if (i != 0) {
            out.push((0, mithril_1.default)("hr"));
        }
        out.push(renderPaymentLine(payments[i], i));
    }
    return out;
}
const PaymentSchemeProvider = new rest_provider_1.RestProvider({
    show: "GET|/contracts/:id/payment_scheme",
    update: "PATCH|/contracts/:contract_id/payment_scheme",
});
exports.PaymentSchemeForm = {
    active: false,
    paymentScheme: {},
    title(form) {
        return `Editer schéma de paiement pour le contrat ${form.obj.contract_id}`;
    },
    view(_vnode) {
        if (this.active) {
            let form = (0, form_for_1.formFor)(this.paymentScheme, PaymentSchemeProvider, (form) => {
                form.setOperationType("edit");
                return (0, modal_1.modalCard)({
                    title: this.title(form),
                    content: renderPayments(form),
                    foot: (0, mithril_1.default)("div", { class: "is-pulled-right" }, form.submit("Mettre à jour", {
                        onsubmit: () => {
                            notification_center_1.Notification.success(`Le schema de paiement #${this.paymentScheme.contract_id} a bien été mis à jour.`);
                            contract_table_1.ContractTable.fetch();
                            payment_table_1.PaymentsTable.fetch();
                            contract_show_1.ContractShow.fetch(this.paymentScheme.contract_id);
                            exports.PaymentSchemeForm.active = false;
                        },
                        disabled: isIllegal(form)
                    })),
                    isActive: exports.PaymentSchemeForm.active,
                    onClose: () => { exports.PaymentSchemeForm.active = false; }
                });
            });
            return form;
        }
        return undefined;
    },
    show(contract) {
        PaymentSchemeProvider.show(contract.id).then((data) => {
            this.paymentScheme = data;
        });
        this.active = true;
    },
};
